import { useState } from "react";
import { Space } from "antd";
import CronItem from "./CronItem";
import FirstRunInput from "./FirstRunInput";
import RunOnceInput from "./RunOnceInput";

export default function({ form, field, ...props }) {
  const [runOnce, setRunOnce] = useState(form.getFieldValue(["crons", field.name, "runOnce"]))

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <RunOnceInput
        form={form}
        field={field}
        setRunOnce={setRunOnce}
        { ...props }
      />
      {
        runOnce
        ?
        <FirstRunInput
          field={field}
          { ...props }
        />
        :
        <CronItem
          form={form}
          field={field}
          { ...props }
        />
      }
    </Space>
  )
}
